/* eslint-disable class-methods-use-this */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import valueOf from "../valueOf";
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export const ApplicationTypes = {
    APPLICATION: "0",
    ATTENDANCE: "1",
    ACHIEVEMENT: "2",
    APPLICATION_CURRICULUM: "3",
    ATTENDANCE_CURRICULUM: "4",
};
type ApplicationType = valueOf<typeof ApplicationTypes>;

interface PayloadBase {
    careerId: string;
}
interface ReqCancelPayload extends PayloadBase {
    classId: string;
}

interface ReqCancelCurriculumPayload extends PayloadBase {}

export interface ReqCancelResponse {}

class ReqCancelService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "reqCancel");
    }

    private setupPayload(payload: PayloadBase, aplType: ApplicationType) {
        return { ...payload, aplType };
    }

    public async cancelApplication(payload: ReqCancelPayload, resolved: (json: ReqCancelResponse) => void, rejected: (error: any) => void) {
        await super.postJSON(
            this.setupPayload(payload, ApplicationTypes.APPLICATION),
            (json: any) => {
                const response = json as ReqCancelResponse;
                resolved(response);
            },
            rejected
        );
    }

    public async cancelApplicationCurriculum(
        payload: ReqCancelCurriculumPayload,
        resolved: (json: ReqCancelResponse) => void,
        rejected: (error: any) => void
    ) {
        await super.postJSON(
            this.setupPayload(payload, ApplicationTypes.APPLICATION_CURRICULUM),
            (json: any) => {
                const response = json as ReqCancelResponse;
                resolved(response);
            },
            rejected
        );
    }
}

export default ReqCancelService;
